// https://api.github.com/newslettersPreferencesPages/michaelbenin
// import { canUseDOM } from 'exenv';

// page loading actions

export function newslettersPreferencesPageLoading(
  newslettersPreferencesPage = {},
  store = {}
) {
  return {
    type: 'NEWSLETTERS_PREFERENCES_PAGE_LOADING',
    newslettersPreferencesPage,
    store
  };
}

export function newslettersPreferencesPageLoaded(
  newslettersPreferencesPage,
  store = {}
) {
  return {
    type: 'NEWSLETTERS_PREFERENCES_PAGE_LOADED',
    newslettersPreferencesPage,
    store
  };
}

export function newslettersPreferencesPageError(error, store = {}) {
  return {
    type: 'NEWSLETTERS_PREFERENCES_PAGE_ERROR',
    newslettersPreferencesPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}

// on submit actions
export function newsletterPreferencesUpdateLoading(isLoading) {
  return {
    type: 'IS_UPDATING_NEWSLETTER_PREFERENCES',
    isLoading
  };
}

export function newsletterPreferencesUpdateSuccess(data) {
  return {
    type: 'UPDATE_NEWSLETTER_PREFERENCES_SUCCESS',
    data,
    isLoading: false
  };
}

export function updateNewsletterPreferencesFailure(error) {
  return {
    type: 'UPDATE_NEWSLETTER_PREFERENCES_FAILURE',
    data: error,
    msg: `Error update newsletter post: ${error}`
  };
}

// changes to state before submit
export function newsletterPreferencesChange(data) {
  return {
    type: 'CHANGE_NEWSLETTER_PREFERENCES',
    data
  };
}

export function newsletterPreferencesChangeRadio(data) {
  return {
    type: 'CHANGE_NEWSLETTER_PREFERENCES_RADIO',
    data
  };
}

export function prepareEmailFieldForChange() {
  return {
    type: 'PREPARE_EMAIL_FIELD_FOR_CHANGE'
  };
}

export function updateSubscriptionEmailSuccess(data) {
  return {
    type: 'UPDATE_SUBSCRIPTION_EMAIL_SUCCESS',
    data
  };
}

export function updateSubscriptionEmailError(data) {
  return {
    type: 'UPDATE_SUBSCRIPTION_EMAIL_ERROR',
    data
  };
}



// WEBPACK FOOTER //
// ./src/redux/action_creators/newsletters_preferences_page_action_creators.js